import React from 'react';
import { Button, Icon } from 'anf-core-react';
import { useOpenAccountToasterAnalyticsEvent } from './helpers';
import { MobileSignInButtonPropTypes, MobileSignInButtonDefaultProps } from './props';

export default function MobileSignInButton({
  isDisabled,
  isLoggedIn,
  isProfileComplete,
  label,
  onClick,
}) {
  const fireAnalyticsEvent = useOpenAccountToasterAnalyticsEvent(isLoggedIn, isProfileComplete);

  const handleClick = () => {
    if (isDisabled) return;
    fireAnalyticsEvent();
    onClick();
  };

  return (
    <div
      className="mobile-sign-in-button-container"
      data-testid="mobile-sign-in-button-container"
    >
      <Button
        isDisabled={isDisabled}
        labelText={label?.value}
        variant="borderless"
        onClick={handleClick}
      >
        <Icon icon="account-circle" />
      </Button>
    </div>
  );
}

MobileSignInButton.propTypes = MobileSignInButtonPropTypes;
MobileSignInButton.defaultProps = MobileSignInButtonDefaultProps;
